export { default } from './ModalTitle';
//# sourceMappingURL=index.js.map